module.exports = __webpack_public_path__ + "static/media/user-white.d8e5c9f9.svg";